import logo from "../../assets/logo.svg";

const partners = ["Unitel", "Movicel", "TV Cabo", "Zap"];
const banks = ["Banco de Fomento", "Banco Atlântico", "BAI", "Standard Bank", "Banco Sol"];
const links = [
  { href: "/policies", label: "Políticas de Uso" },
  { href: "/terms", label: "Termos e Condições" },
  { href: "/privacy", label: "Privacidade" },
];

export default function Footer() {
  return (
    <footer className="bg-brand text-white">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-4 gap-10 pb-12 max-md:grid-cols-2 max-sm:grid-cols-1">

          {/* Brand */}
          <div>
            <img src={logo} alt="PIA" className="h-9 mb-4" />
            <p className="text-white/55 text-sm leading-relaxed">
              Pagamentos Institucional Angolano — simplificando o processo
              de pagamento de propinas em Angola.
            </p>
          </div>

          {/* Parceiros Fies */}
          <div>
            <h3 className="text-white/45 text-xs font-semibold uppercase tracking-widest mb-4">
              Parceiros Fies
            </h3>
            <ul className="space-y-2.5">
              {partners.map((n) => (
                <li key={n}>
                  <a href="#" className="text-white/65 hover:text-white text-sm transition-colors">{n}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Parceiros Bancários */}
          <div>
            <h3 className="text-white/45 text-xs font-semibold uppercase tracking-widest mb-4">
              Parceiros Bancários
            </h3>
            <ul className="space-y-2.5">
              {banks.map((n) => (
                <li key={n}>
                  <a href="#" className="text-white/65 hover:text-white text-sm transition-colors">{n}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contactos */}
          <div>
            <h3 className="text-white/45 text-xs font-semibold uppercase tracking-widest mb-4">
              Contactos
            </h3>
            <ul className="space-y-2 text-sm text-white/65 mb-5">
              <li>Benfica, Luanda, Angola</li>
              <li>(+244) 944-969-865</li>
              <li>pia.server@pco.co.ao</li>
            </ul>
            <ul className="space-y-2">
              {links.map(({ href, label }) => (
                <li key={href}>
                  <a href={href} className="text-white/65 hover:text-white text-sm transition-colors">{label}</a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-white/10 flex items-center justify-between max-sm:flex-col max-sm:gap-2 text-white/35 text-xs">
          <p>© 2024 PIA – Todos os direitos reservados</p>
          <p>Desenvolvido com ♥ em Angola</p>
        </div>
      </div>
    </footer>
  );
}
